import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
	(
		<Suspense fallback={<SuspenseLoader />}>
			<Component {...props} />
		</Suspense>
	);

const List = Loader(lazy(() => import('src/content/trainings/List')));
const Create = Loader(lazy(() => import('src/content/trainings/Create')));
const Invoices = Loader(lazy(() => import('src/content/trainings/Invoices')));
const MultiInvoices = Loader(lazy(() => import('src/content/trainings/MultiInvoices')));

const trainingsRoutes = [
	{
		path: '',
		element: <Navigate to="list" replace />
	},
	{
		path: 'list',
		element: <List />
	},
	{
		path: 'list/create',
		element: <Create />
	},
	{
		path: 'list/edit/:id',
		element: <Create />
	},
	{
		path: 'invoices',
		element: <Invoices />
	},
	{
		path: 'multi-invoices/:id',
		element: <MultiInvoices />
	}
];

export default trainingsRoutes;
